import { apiClient } from '@/libs/axios';
import type { ApiParamsDefault, ApiResponsePagination } from '@/types/api.type';
import { queryOptions } from '@tanstack/react-query';
import type {
  Product,
  ProductStatus,
  ProductType,
} from '../types/product.type';

export type GetListProductParams = Partial<ApiParamsDefault> & {
  scheme?: 'free' | 'paid';
  sort_by?:
    | 'price'
    | 'name'
    | 'status'
    | 'type'
    | 'created_at'
    | 'published_at';
  sort_order?: 'asc' | 'desc';
  type?: ProductType;
  status?: ProductStatus[];
};
export type GetListProductResponse = ApiResponsePagination<Product>;

export const getListProduct = async (
  params?: GetListProductParams
): Promise<GetListProductResponse> => {
  const url = 'product';

  return await apiClient.get(url, { params });
};

export const GET_LIST_PRODUCT_QUERY_KEY = 'list-product';
export function getListProductQueryOptions(params?: GetListProductParams) {
  return queryOptions({
    queryKey: [GET_LIST_PRODUCT_QUERY_KEY, params],
    queryFn: () => getListProduct(params),
  });
}
